import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import CheckIcon from '@mui/icons-material/Check';
import max from 'lodash/max';
import { ReactElement, useMemo } from 'react';

// Core.
import { ILearnerCredit } from 'core';

interface IStateCreditsProps {
  abbreviation: string;
  credits: ILearnerCredit[];
}

export const StateCredits = (props: IStateCreditsProps): ReactElement => {
  const { abbreviation, credits = [] } = props;
  const accepted: ILearnerCredit[] = credits.filter((c) => c.isAccepted);
  const notAccepted: ILearnerCredit[] = credits.filter((c) => !c.isAccepted);
  const acceptedCredits: number = useMemo(() => max(credits.map(({ acceptedCredits }) => acceptedCredits)), [credits]);
  const units: string = useMemo(() => credits[0]?.units || 'Credits', [credits]);

  return (
    <>
      <Grid size={{ xs: 1 }} />
      <Grid size={{ xs: 11 }}>
        <strong>
          {acceptedCredits} {abbreviation} {units}
        </strong>
      </Grid>
      {accepted.length > 0 && (
        <>
          <Grid container size={{ xs: 1 }} sx={{ justifyContent: 'flex-end' }}>
            <CheckIcon sx={{ colorPrimary: { fill: '#82bc00' } }} />
          </Grid>
          <Grid size={{ xs: 11 }}>
            <Box>
              {accepted
                .map(({ stateAbbreviation }) => stateAbbreviation)
                .filter(Boolean)
                .join(', ')}
            </Box>
          </Grid>
        </>
      )}
      {notAccepted.length > 0 && (
        <>
          <Grid container size={{ xs: 1 }} sx={{ justifyContent: 'flex-end' }}>
            {' '}
          </Grid>
          <Grid size={{ xs: 11 }}>
            <Box>
              {notAccepted
                .map(({ stateAbbreviation }) => stateAbbreviation)
                .filter(Boolean)
                .join(', ')}
            </Box>
          </Grid>
        </>
      )}
    </>
  );
};
